import './sentry'; // boshqa hamma narsadan OLDIN — erta xatolarni ham tutishi uchun
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import store from './store';
import { logout } from './store/authSlice';
import reportWebVitals from './reportWebVitals';

// Xodim (admin) paneli bilan bir xil brauzerda ochilishi mumkin — token va
// interceptor mustaqil ("client_token"), shu sababli bir-biriga xalaqit bermaydi.
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/client\/auth\/login/.test(url);
    if (status === 401 && localStorage.getItem('client_token') && !isAuthCall) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
